import type { ReactNode } from "react";
import { NavLink, useLocation } from "react-router-dom";

const nav = [
  ["/", "Today", "⌂"],
  ["/history", "History", "↗"],
  ["/body", "Body", "◎"],
  ["/goals", "Goals", "◇"]
] as const;

export function Layout({ children, onLogout, androidUpdate = null }: { children: ReactNode; onLogout: () => void; androidUpdate?: string | null }) {
  const location = useLocation();
  const activeWorkout = location.pathname.startsWith("/workout/");
  return <div className="app-shell">
    {!activeWorkout && <header className="topbar">
      <NavLink to="/" className="brand"><span className="brand-mark">G</span><span>Gym</span></NavLink>
      <div className="topbar-actions">
        {!navigator.onLine && <span className="offline-pill">Offline</span>}
        {androidUpdate && <span className="update-pill">Update {androidUpdate}</span>}
        <button className="icon-button" onClick={onLogout} aria-label="Log out">↪</button>
      </div>
    </header>}
    <main className={activeWorkout ? "main workout-main" : "main"}>{children}</main>
    {!activeWorkout && <nav className="bottom-nav">
      {nav.map(([to, label, icon]) => <NavLink key={to} to={to} end={to === "/"}>
        <span className="nav-icon">{icon}</span><span>{label}</span>
      </NavLink>)}
    </nav>}
  </div>;
}

export function PageHeader({ eyebrow, title, action }: { eyebrow?: string; title: string; action?: ReactNode }) {
  return <div className="page-header">
    <div>{eyebrow && <div className="eyebrow">{eyebrow}</div>}<h1>{title}</h1></div>
    {action}
  </div>;
}

export function Loading() { return <div className="center-state"><div className="loader"/><p>Loading</p></div>; }
export function ErrorState({ message, retry }: { message: string; retry?: () => void }) {
  return <div className="empty-state"><strong>Something went wrong</strong><p>{message}</p>{retry && <button onClick={retry}>Try again</button>}</div>;
}
